import { render, staticRenderFns } from "./AppNavBar.vue?vue&type=template&id=52d23817&scoped=true&"
import script from "./AppNavBar.vue?vue&type=script&lang=ts&"
export * from "./AppNavBar.vue?vue&type=script&lang=ts&"
import style0 from "./AppNavBar.vue?vue&type=style&index=0&id=52d23817&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d23817",
  null
  
)

export default component.exports